module.exports = __webpack_public_path__ + "img/stage-2.c6eec420.png";